import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageTransition from '../components/PageTransition';

export default function NotFoundPage() {
  return (
    <PageTransition>
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, var(--slate-dark) 0%, #2d1515 60%, #1a0c0a 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '120px 24px 80px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }} />
        <div style={{
          position: 'absolute',
          width: '600px', height: '600px', borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(192,57,43,0.15) 0%, transparent 70%)',
          top: '-200px', right: '-100px', pointerEvents: 'none',
        }} />
        <motion.div
          style={{ position: 'relative', zIndex: 1 }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p style={{
            fontFamily: 'var(--font-serif)',
            fontSize: 'clamp(5rem, 15vw, 10rem)',
            fontWeight: 900,
            background: 'linear-gradient(135deg, #c0392b, #d35400)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            lineHeight: 1,
            marginBottom: 16,
          }}>
            404
          </p>
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', color: 'white', marginBottom: 14 }}>
            Sayfa Bulunamadı
          </h1>
          <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.52)', maxWidth: 420, margin: '0 auto 36px', lineHeight: 1.75 }}>
            Aradığınız sayfa taşınmış, silinmiş ya da hiç var olmamış olabilir.
          </p>
          <Link to="/" className="btn-primary" style={{ display: 'inline-flex' }}>
            Ana Sayfaya Dön
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="15" height="15"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </Link>
        </motion.div>
      </div>
    </PageTransition>
  );
}
